import moment from "moment";
import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
import React from "react";
import styles from "../index.module.css";

interface ParamProps {
  fieldName: string;
  currentObject: any;
  isDisable?: boolean;
  isInvalid?: boolean;
  getValue: Date | undefined | null;
  view?: "month" | "date" | "year" | undefined;
  dateFormat?: string;
  maxDate?: Date;
  minDate?: Date;
  timeOnly?: boolean;
  hourFormat?: "12" | "24";
  showButtonBar?: boolean;
  placeholder?: string;
  setValue: (updatedObject: any) => void;
  style?: React.CSSProperties;
}

const MobileInputDateComponent: React.FC<ParamProps> = (params: ParamProps) => {
  const dateFormat = params.dateFormat ?? "dd/mm/yy";
  const handleChange = (e: { value: Date | null | undefined }) => {
    const newValue = e.value;
    // ? moment(e.value).utc().format("YYYY/MM/DD")
    // : null;
    const updatedObject = {
      ...params.currentObject,
      [params.fieldName]: newValue,
    };
    params.setValue(updatedObject);
  };

  let date;

  addLocale("pt", {
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "segunda-feira",
      "terça-feira",
      "quarta-feira",
      "quinta-feira",
      "sexta-feira",
      "sábado",
    ],
    dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    monthNames: [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro",
    ],
    monthNamesShort: [
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dez",
    ],
    today: "Hoje",
    clear: "Limpar",
  });

  const ano = new Date(params?.getValue || 0).getFullYear();
  const mes = new Date(params?.getValue || 0).getMonth();
  const dia = new Date(params?.getValue || 0).getDate();
  const numberUtcDate = new Date().setUTCFullYear(ano, mes, dia);
  date = new Date(numberUtcDate);

  if (params.view === "month" && params?.getValue) {
    date = new Date(params?.getValue);
  }

  if (params.timeOnly && params?.getValue) {
    date = new Date(params?.getValue);
  }

  return (
    <Calendar
    id={params.fieldName}
    showIcon
    className="w-full"
    value={params.getValue ? date : null}
    disabled={params.isDisable || false}
    invalid={params.isInvalid || false}
    onChange={handleChange}
    view={params.view || "date"}
    dateFormat={dateFormat}
    maxDate={params.maxDate}
    minDate={params.minDate}
    timeOnly={params.timeOnly}
    hourFormat={params.hourFormat}
    showButtonBar={params.showButtonBar}
    placeholder={params.placeholder}
    locale="pt"
    inputStyle={params.style}

    />
  );
};

export default MobileInputDateComponent;
